import * as  style from "./ProductSelection-module.less";
import { PaymentController } from "features/payment"
import "styles/foundation/forms.less";


class ProductSelectionElement extends HTMLElement {
    private level = () => this.getAttribute("membership-level");
    private loggedIn = () => this.hasAttribute("logged-in");

    connectedCallback() {
        this.innerHTML = this.view();
        this.classList.add(style.pricing);

        if (this.loggedIn()) {
            [].slice.call(this.querySelectorAll(".available")).forEach((element: HTMLElement) => {
                element.addEventListener("click", async (event) => {
                    await new PaymentController().pay();
                });
    
            });
        } else {
            [].slice.call(this.querySelectorAll(".tier")).forEach((element: HTMLElement) => {
                element.addEventListener("click", () => {
                    window.location.href = `/login?returnurl=${window.location.pathname}`;
                });
            });
        }
    }

    private getText(type: string) {
        if (!this.loggedIn())
            return "Login to activate";

        if (this.level() === type)
            return "Current subscription";

        if (type === "premium")
            return "Activate";

        return "";
    }

    private view = () => `
        <header class=${style.header}>
            By signing up you support future development of Linkstacks.
        </header>

        <div class="tier ${this.level() === "basic" ? "current" : ""}">
            <header>Basic</header>
            <div class="feature">
                Nag screen
            </div>
            <div class="feature">
                Unlimited links
            </div>
            <div class="feature">
                Unlimited stacks
            </div>
            <div class="feature">
                Filters
            </div>
            <div class="feature">
                Browser plugin
            </div>
            <div class="feature">
                Deep search
            </div>
            <div class="feature">
                -
            </div>
            <div class="price">
                $0&nbsp;<span>/ MONTH</span>
            </div>
            <div class="action">
                ${this.getText("basic")}
            </div>

        </div>


        <div class="tier ${this.level() === "premium" ? "current" : "available"}">
            <header>Premium</header>
            <div class="feature">
                -
            </div>
            <div class="feature">
                Unlimited links
            </div>
            <div class="feature">
                Unlimited stacks
            </div>
            <div class="feature">
                Filters
            </div>
            <div class="feature">
                Browser plugin
            </div>
            <div class="feature">
                Deep search
            </div>
            <div class="feature">
                Email support
            </div>
            <div class="price">
                $1.25&nbsp;<span>/ MONTH *</span>
            </div>
            <div class="action">
                ${this.getText("premium")}
            </div>
        </div>

        <div class="tier ${this.level() === "professional" ? "current" : ""}">
            <header>Professional</header>
            <div class="feature">
                -
            </div>
            <div class="feature">
                Unlimited links
            </div>
            <div class="feature">
                Unlimited stacks
            </div>
            <div class="feature">
                Filters
            </div>
            <div class="feature">
                Browser plugin
            </div>
            <div class="feature">
                Deep search
            </div>
            <div class="feature">
                Full support
            </div>
            <div class="price">
                $5&nbsp;<span>/ MONTH *</span>
            </div>
            <div class="action">
                Coming soon
            </div>
        </div>
        <div class="${style.note}">
            * When subscribing for a year.
        </div>
    `;
}


customElements.define("product-selection", ProductSelectionElement);